"use client";
import ResumesModal from "@/app/_components/share/ApplyJob/ResumesModal";
import { useModal } from "@/app/_components/share/Modal";
import { UserType } from "@/services/constants/global";
import { SIGNIN_PAGE } from "@/services/constants/routerPath";
import { useUserInfo } from "@/services/hooks/useUserInfo";
import { Box, Button } from "@chakra-ui/react";
import { usePathname, useRouter } from "next/navigation";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useIsClient } from "usehooks-ts";

export default function ApplyJob({
  jobId = "",
  jobTitle = "",
  jobPositions = [],
  isDisabled = false,
  buttonStyles = {},
  ...props
}) {
  const { push } = useRouter();
  const pathname = usePathname();
  const { t } = useTranslation();
  const user = useUserInfo();

  const [openModal, closeModal] = useModal();
  const [isApplied, setApplied] = useState(false);

  const isClient = useIsClient();

  const onOpenModalClick = () => {
    if (!user) {
      push(`${SIGNIN_PAGE}?redirect=${pathname}&id=${jobId}`);
      return;
    }
    openModal({
      title: t("Resume editor"),
      body: (
        <ResumesModal
          jobId={jobId}
          jobTitle={jobTitle}
          jobPositions={jobPositions}
          close={closeModal}
          setAppliedSuccessfully={setApplied}
        />
      ),
      placement: "bottom",
      isCompact: true,
      props: { size: "xl", scrollBehavior: "inside" },
    });
  };

  const isShowApplyButton =
    isClient && (!user || (user && user.type === UserType.PERSONAL));

  return (
    isShowApplyButton && (
      <Box position="relative" w="fit-content" h="fit-content" {...props}>
        <Button
          w="full"
          variant="outline"
          isDisabled={isDisabled || isApplied}
          px={{ base: 2, lg: 4 }}
          {...buttonStyles}
        >
          {t("Apply job")}
        </Button>
        <Button
          top={0}
          left={0}
          variant="ghost"
          position="absolute"
          w="full"
          h="full"
          onClick={(e) => {
            e.stopPropagation();
            onOpenModalClick();
          }}
          isDisabled={isDisabled || isApplied}
        ></Button>
      </Box>
    )
  );
}
